var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.501,
    height: 21.501,
    viewBox: "0 0 21.501 21.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin-icon",
    d: "M5.88,17.763H4.62a.84.84,0,0,1-.84-.84V9.113a.84.84,0,0,1,.84-.84H5.88a.84.84,0,0,1,.84.84v7.811A.84.84,0,0,1,5.88,17.763ZM7.013,5.249A1.722,1.722,0,1,0,5.292,6.971,1.722,1.722,0,0,0,7.013,5.249ZM17.722,16.923V12.542c0-2.548-.538-4.437-3.514-4.437a3.051,3.051,0,0,0-2.782,1.459h0V9.113a.84.84,0,0,0-.84-.84H9.407a.84.84,0,0,0-.84.84v7.811a.84.84,0,0,0,.84.84h1.176a.84.84,0,0,0,.84-.84V13.051c0-1.234.314-2.43,1.844-2.43,1.509,0,1.558,1.411,1.558,2.508v3.794a.84.84,0,0,0,.84.84h1.218a.84.84,0,0,0,.84-.84ZM21.5,18.141a.84.84,0,0,0-1.68,0,1.682,1.682,0,0,1-1.68,1.68H3.36a1.682,1.682,0,0,1-1.68-1.68V3.36A1.682,1.682,0,0,1,3.36,1.68H18.142a1.682,1.682,0,0,1,1.68,1.68V13.9a.84.84,0,0,0,1.68,0V3.36A3.363,3.363,0,0,0,18.142,0H3.36A3.363,3.363,0,0,0,0,3.36V18.141A3.363,3.363,0,0,0,3.36,21.5H18.142A3.363,3.363,0,0,0,21.5,18.141Zm0,0",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.bb4880989c3f4f916c8f66aa2e3472c5.svg";
export { ForwardRef as ReactComponent };